import { useMutation, useQuery } from 'react-query'

import { queryClient } from 'store/state'

import {
  getMyFlagsApi,
  getUserFlagsApi,
  setUserFlagApi
} from './api'
import { QUERY_KEYS } from './constants'

export const useFeatureFlags = () => {
  const { data: flags, isLoading } = useQuery(
    QUERY_KEYS.MY_FLAGS,
    getMyFlagsApi
  )

  const isEnabled = key => Boolean(flags && flags[key])

  return { flags: flags || {}, isLoading, isEnabled }
}

export const useUserFeatureFlags = userId => {
  const queryKey = [QUERY_KEYS.USER_FLAGS, userId]
  const { data: flags, isLoading, refetch } = useQuery(
    queryKey,
    () => getUserFlagsApi(userId),
    { enabled: Boolean(userId) }
  )

  const { mutate: setFlag, isLoading: isSaving } = useMutation(
    setUserFlagApi,
    {
      onSuccess: data => {
        queryClient.setQueryData(queryKey, data)
      }
    }
  )

  return {
    flags: flags || [],
    isLoading,
    isSaving,
    refetch,
    setFlag
  }
}
